import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from '../string';
import { areaCategoryValidator } from './area-category';
import { screenValidator } from './screen-validator';
import { seatAvailabilityValidator } from './seat-availability';
import { seatLayoutValidator } from './seat-layout';
import { seatSelectionLimitsValidator } from './seat-selection-limits';
export const seatingDataValidator = Validator.object({
    seatLayout: seatLayoutValidator,
    areaCategories: Validator.array({ items: areaCategoryValidator }),
    seatAvailabilities: Validator.array({ items: seatAvailabilityValidator }),
    reservedSeatIds: Validator.array({ items: nonEmptyStringValidator }),
    friendSeatIds: Validator.optional(Validator.array({ items: nonEmptyStringValidator })),
    seatSelectionLimits: seatSelectionLimitsValidator,
    screen: screenValidator,
    siteId: nonEmptyStringValidator
});
